module.exports = __webpack_public_path__ + "images/top-sellers-black-709b802f.svg";